import licenseSeatsManagementTemplate from './license-seats-management.component.html';

/* @ngInject */
export const templatesRun = ($templateCache) => {
	$templateCache.put(
		'components/license-seats-management/license-seats-management.component.html',
		licenseSeatsManagementTemplate
	);
};
